import { pxToRem, media, theme } from '@vfit/shared/themes';
import styled from '@emotion/styled';
import { IMargins } from './Skeleton.models';

export const Wrapper = styled.div<IMargins>`
  margin: ${({ margins }) =>
    margins != undefined && !Array.isArray(margins) ? theme.spacing[margins] : '0'};

  ${media.tablet`
    ${({ tabletMargins }) =>
      tabletMargins != undefined ? `margin: ${pxToRem(...tabletMargins)}` : null}
  `}
`;

export const Container = styled.div<{ itemsDistance?: number }>`
  div {
    margin-bottom: ${({ itemsDistance }) =>
      itemsDistance != undefined ? `${itemsDistance}` : '35'}px;
  }
`;

